import { FilterOperator } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { ApplicationList } from '@/components/shared/components/ApplicationList/ApplicationList';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

export const ChannelApplicationsList = () => {
  const { merchantId, channelId } = useParams();

  if (!merchantId || !channelId) return null;

  const channelFilter = [
    {
      field: 'channel_id',
      operator: FilterOperator.EQUAL,
      value: channelId,
    },
  ];

  return <ApplicationList merchantId={merchantId} channelId={channelId} filters={channelFilter} />;
};

export const ChannelApplicationsListModule = withPermissionsModule(ChannelApplicationsList);
